import { platformEnv } from '@/platform/config/env'
import { createHttpClient } from '@/platform/http/client'

export interface SsoUser {
  id: number
  email: string
  display_name: string | null
  avatar: string | null
  role: string
}

const client = createHttpClient(platformEnv.ssoApiUrl)

export const ssoUsersApi = {
  async searchByEmail(email: string): Promise<SsoUser | null> {
    const query = email.trim()
    if (!query) return null

    const result = await client.request<SsoUser[]>({
      url: '/v1/admin/users/search',
      params: { q: query, page: 1, size: 10 },
    })

    const users = result.data ?? []
    if (users.length === 0) return null

    // Ưu tiên khớp chính xác email (không phân biệt hoa thường)
    const exact = users.find((u) => u.email.toLowerCase() === query.toLowerCase())
    if (exact) return exact

    // Nếu không có exact, tìm user có email chứa query
    const partial = users.find((u) => u.email.toLowerCase().includes(query.toLowerCase()))
    return partial ?? users[0]
  },
}
